import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorHandleService } from './error-handle.service';
import { catchError, Observable } from 'rxjs';
import { Sales, SalesContactInfo, SalesDetailListResponse, SalesDetailResponse, SalesFinanceInfoResponse, SalesProgressResponse, SalesPropertyStateResponse, SalesResponse, TotalEventPropertyResponse, TransStatusResponse } from '../models/sales';
import { of } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { ActivityState, ActivityStateResponse, HouseSalesPerformance, HouseSalesPerformanceResponse, SalesActivityList, SalesActivityListResponse, SalesDetailSummaryResponse, SalesTeamResponse, SalesTypePerformance, SalesTypePerformanceResponse } from '../models/list-sales-performance';

@Injectable({
  providedIn: 'root'
})
export class SalesActivitiesService {

  private apiUrl = `${environment.APIDEV}`;

  constructor(
    private http: HttpClient,
    private errorHandle: ErrorHandleService
  ) { }

  getSales(
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    filter?: string, // Parameter ini sesuai dengan API backend
    sortOrder?: 'ASC' | 'DESC',
    startDate?: string,
    endDate?: string
  ): Observable<SalesResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());

    if (search) {
      params = params.set('search', search);
    }

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    // PERBAIKAN: Hanya gunakan parameter 'filter' sesuai dengan API backend
    if (filter) {
      params = params.set('filter', filter);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesResponse>(`${this.apiUrl}sales_activity/list`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesPropertyState(
    startDate?: string,
    endDate?: string
  ): Observable<SalesPropertyStateResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesPropertyStateResponse>(`${this.apiUrl}sales_activity/state`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getTransStatus(): Observable<TransStatusResponse> {
    return this.http.get<TransStatusResponse>(`${this.apiUrl}sales_activity/trans_status`, {
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getTotalEventProperty(
    startDate?: string,
    endDate?: string
  ): Observable<TotalEventPropertyResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<TotalEventPropertyResponse>(`${this.apiUrl}sales_activity/total_event_property_activity`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesDetailList(
    id: string | number,
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: string,
    startDate?: string,
    endDate?: string
  ): Observable<SalesDetailListResponse> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesDetailListResponse>(`${this.apiUrl}sales_activity/detail/${id}/list`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesDetail(
    id?: number | null,
    startDate?: string,
    endDate?: string
  ): Observable<SalesDetailResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesDetailResponse>(`${this.apiUrl}sales_activity/detail/${id}`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesDetailContactInfo(
    id?: number | null,
    startDate?: string,
    endDate?: string
  ): Observable<SalesContactInfo> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesContactInfo>(`${this.apiUrl}sales_activity/detail/${id}/contact_info`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesTeam(
    startDate?: string,
    endDate?: string
  ): Observable<SalesTeamResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesTeamResponse>(`${this.apiUrl}sales_activity/sales_team`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesTypePerformance(
    startDate?: string,
    endDate?: string
  ): Observable<SalesTypePerformanceResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesTypePerformanceResponse>(`${this.apiUrl}sales_activity/sales_type_performance`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getHouseSalesPerformance(
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: string,
    startDate?: string,
    endDate?: string
  ): Observable<HouseSalesPerformanceResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<HouseSalesPerformanceResponse>(`${this.apiUrl}sales_activity/in_house_sales`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesSummaryById(
    id?: number | null,
    startDate?: string,
    endDate?: string
  ): Observable<SalesDetailSummaryResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesDetailSummaryResponse>(`${this.apiUrl}sales_activity/in_house_sales/detail/${id}/summary`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getSalesActivityStateById(
    id?: number | null,
    startDate?: string,
    endDate?: string
  ): Observable<ActivityStateResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<ActivityStateResponse>(`${this.apiUrl}sales_activity/in_house_sales/detail/${id}/state_tracking`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }


  getSalesActivityList(
    id_property: number | null,
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: string,
    startDate?: string,
    endDate?: string
  ): Observable<SalesActivityListResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<SalesActivityListResponse>(`${this.apiUrl}sales_activity/in_house_sales/detail/${id_property}/activity_list`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );

  }

  getSalesFinanceInfo(
    id?: number | null,
    startDate?: string,
    endDate?: string,
    tax?: string,
    rev_category?: string,
    price?: string
  ): Observable<SalesFinanceInfoResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    if (tax) {
      params = params.set('tax', tax);
    }

    if (rev_category) {
      params = params.set('rev_category', rev_category);
    }

    if (price) {
      params = params.set('price', price);
    }

    return this.http.get<SalesFinanceInfoResponse>(`${this.apiUrl}sales_activity/detail/${id}/finance_info`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }
}
